import { render, staticRenderFns } from "./UsersNew.vue?vue&type=template&id=120977a8&"
import script from "./UsersNew.vue?vue&type=script&lang=js&"
export * from "./UsersNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports